// Hero Slider Scripts

document.addEventListener('DOMContentLoaded', function() {
  // ==============================================
  // Desktop Mega Menu Functionality
  // ==============================================
  var menu = document.querySelector('.hero-mega-menu');
  if (!menu) return;
  var items = menu.querySelectorAll('.hero-mega-menu__item');
  var openClass = 'hero-mega-menu__item--open';
  var opened = null;
  var lastScrollY = window.scrollY;
  var delta = 2;
  var pendingDropdownItem = null;

  function updateMegaMenuTop() {
    var header = document.querySelector('.header, .shopify-section-header');
    var headerHeight = header ? header.offsetHeight : 80;
    if (menu.classList.contains('hero-mega-menu--fixed')) {
      menu.style.top = headerHeight + 'px';
    } else {
      menu.style.top = '';
    }
  }
  window.addEventListener('resize', updateMegaMenuTop);
  updateMegaMenuTop();

  function updateDropdownPosition() {
    var isFixed = menu.classList.contains('hero-mega-menu--fixed');
    var menuRect = menu.getBoundingClientRect();
    var top = menuRect.bottom;
    document.querySelectorAll('.hero-mega-menu__item.' + openClass + ' > .hero-mega-menu__dropdown').forEach(function(dropdown) {
      if (isFixed) {
        dropdown.style.position = 'fixed';
        dropdown.style.top = top + 'px';
        dropdown.style.left = '0';
        dropdown.style.width = '100vw';
        dropdown.style.zIndex = '1000';
      } else {
        dropdown.style.position = '';
        dropdown.style.top = '';
        dropdown.style.left = '';
        dropdown.style.width = '';
        dropdown.style.zIndex = '';
      }
    });
  }
  window.addEventListener('resize', updateDropdownPosition);
  window.addEventListener('scroll', updateDropdownPosition);

  function updateMegaMenuDropdownTop() {
    var rect = menu.getBoundingClientRect();
    var scrollY = window.scrollY || window.pageYOffset;
    var top = rect.bottom + scrollY;
    document.documentElement.style.setProperty('--hero-mega-menu-top', top + 'px');
  }
  window.addEventListener('resize', updateMegaMenuDropdownTop);
  window.addEventListener('scroll', updateMegaMenuDropdownTop);
  updateMegaMenuDropdownTop();

  window.addEventListener('scroll', function() {
    var scrollY = window.scrollY || window.pageYOffset;
    updateMegaMenuTop();
    if (scrollY <= 0) {
      menu.classList.remove('hero-mega-menu--fixed');
      menu.classList.remove('hero-mega-menu--hidden');
      menu.style.top = '';

      if (pendingDropdownItem) {
        pendingDropdownItem.classList.add(openClass);
        updateMegaMenuDropdownTop();
        lockBodyScroll(anyMenuOpen());
        updateDropdownPosition();
        pendingDropdownItem = null;
      }
    } else if (scrollY > lastScrollY + delta) {
      menu.classList.remove('hero-mega-menu--fixed');
      menu.classList.add('hero-mega-menu--hidden');
      menu.style.top = '';
    } else if (scrollY < lastScrollY - delta) {
      menu.classList.add('hero-mega-menu--fixed');
      menu.classList.remove('hero-mega-menu--hidden');
      updateMegaMenuTop();

      items.forEach(function(item) {
        item.classList.remove(openClass);
      });
    }
    lastScrollY = scrollY;
    updateDropdownPosition();
  });

  function anyMenuOpen() {
    return Array.from(items).some(function(item) {
      return item.classList.contains(openClass);
    });
  }

  function lockBodyScroll(lock) {
    if (lock) {
      document.body.classList.add('megamenu-lock-scroll');
    } else {
      document.body.classList.remove('megamenu-lock-scroll');
    }
  }

  items.forEach(function(item) {
    var btn = item.querySelector('button');
    var dropdown = item.querySelector('.hero-mega-menu__dropdown');
    if (!btn || !dropdown) return;
    btn.addEventListener('click', function(e) {
      var dropdown = item.querySelector('.hero-mega-menu__dropdown');
      if (!dropdown) {
        var link = item.querySelector('a');
        if (link) {
          window.location.href = link.href;
        }
        return;
      }
      e.preventDefault();
      
      items.forEach(function(it) {
        if (it !== item) {
          it.classList.remove(openClass);
        }
      });
      
      var isOpen = item.classList.contains(openClass);
      if (isOpen) {
        item.classList.remove(openClass);
      } else {
        if (menu.classList.contains('hero-mega-menu--fixed')) {
          window.scrollTo({top: 0, behavior: 'smooth'});
          pendingDropdownItem = item;
        } else {
          item.classList.add(openClass);
          updateMegaMenuDropdownTop();
          lockBodyScroll(anyMenuOpen());
          updateDropdownPosition();
        }
      }
    });
    
    document.addEventListener('click', function(e) {
      if (!item.contains(e.target)) {
        item.classList.remove(openClass);
        lockBodyScroll(anyMenuOpen());
        updateDropdownPosition();
      }
    });
  });

  function updateHeaderHeight() {
    const header = document.querySelector('.slider-header-bar');
    if (header) {
      const headerHeight = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }
  }
  
  window.addEventListener('resize', updateHeaderHeight);
  updateHeaderHeight();

  // Sidebar functionality
  window.openSidebar = function() {
    const sidebar = document.querySelector('.menu-sidebar');
    if (sidebar) {
      sidebar.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  // Close button functionality
  const closeButton = document.querySelector('.menu-sidebar .close-button');
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      const sidebar = document.querySelector('.menu-sidebar');
      if (sidebar) {
        sidebar.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  // Close sidebar when clicking outside
  document.addEventListener('click', function(event) {
    const sidebar = document.querySelector('.menu-sidebar');
    const burgerMenu = document.querySelector('.burger-menu--desktop');
    if (sidebar && sidebar.classList.contains('active')) {
      if (!sidebar.contains(event.target) && !burgerMenu.contains(event.target)) {
        sidebar.classList.remove('active');
        document.body.style.overflow = '';
      }
    }
  });

  // Burger menu functionality
  const burgerMenuDesktop = document.querySelector('.burger-menu--desktop');
  const menuSidebar = document.querySelector('.menu-sidebar');
  const closeButtonBurger = menuSidebar?.querySelector('.close-button');

  if (burgerMenuDesktop && menuSidebar) {
    burgerMenuDesktop.addEventListener('click', function() {
      menuSidebar.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }

  if (closeButtonBurger && menuSidebar) {
    closeButtonBurger.addEventListener('click', function() {
      menuSidebar.classList.remove('active');
      document.body.style.overflow = '';
    });

    // Close on click outside
    document.addEventListener('click', function(e) {
      if (menuSidebar.classList.contains('active') && 
          !menuSidebar.contains(e.target) && 
          !burgerMenuDesktop.contains(e.target)) {
        menuSidebar.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  // ==============================================
  // Show More / Show Less functionality
  // ==============================================
  const showMoreButtons = document.querySelectorAll('.hero-mega-menu__show-more');
  
  showMoreButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const column = this.closest('.hero-mega-menu__column-content');
      const hiddenItems = column.querySelector('.hero-mega-menu__hidden-items');
      const showText = this.getAttribute('data-show-text') || 'více';
      const hideText = this.getAttribute('data-hide-text') || 'méně';
      
      if (hiddenItems) {
        if (hiddenItems.classList.contains('show')) {
          hiddenItems.classList.remove('show');
          this.innerHTML = showText;
        } else {
          hiddenItems.classList.add('show');
          this.innerHTML = hideText;
        }
      }
    });
  });
});

// ==============================================
// Random Banner Functionality
// ==============================================
document.addEventListener('DOMContentLoaded', function() {
  // Background color is set via Liquid template in hero-slider.liquid
  
  const toggleButton = document.querySelector('.random-banner__description-toggle');
  const description = document.querySelector('.random-banner__description');
  
  if (toggleButton && description) {
    toggleButton.addEventListener('click', function() {
      description.classList.toggle('expanded');
      toggleButton.classList.toggle('expanded');
      
      if (description.classList.contains('expanded')) {
        toggleButton.querySelector('.toggle-text').textContent = 'Show less';
      } else {
        toggleButton.querySelector('.toggle-text').textContent = 'Show more';
      }
    });
  }
});

// ==============================================
// Account Badge Tooltip
// ==============================================
document.addEventListener('DOMContentLoaded', function() {
  var badge = document.querySelector('.account-badge');
  var tooltip = badge ? badge.querySelector('.account-badge-tooltip') : null;
  
  if (!badge || !tooltip) {
    return;
  }

  var red = badge.querySelector('.account-badge__text')?.textContent.replace('%','').trim() || '';
  var green = '';
  
  // Green discount is set via Liquid template in hero-slider.liquid

  var badgeTooltipTexts = {
    bg: "Вашата отстъпка RED е {red}%. Green отстъпка {green}%.",
    cs: "Vaše velkoobchodní sleva RED je {red}%. Sleva Green {green}%.",
    da: "Din RED-rabat er {red}%. Green-rabat {green}%.",
    de: "Ihr RED-Rabatt beträgt {red}%. Green-Rabatt {green}%.",
    el: "Η έκπτωση RED είναι {red}%. Έκπτωση Green {green}%.",
    en: "Your wholesale RED discount is {red}%. Green discount {green}%.",
    es: "Su descuento RED es {red}%. Descuento Green {green}%.",
    fi: "RED-alennuksesi on {red}%. Green-alennus {green}%.",
    fr: "Votre remise RED est de {red}%. Remise Green {green}%.",
    hr: "Vaš RED popust je {red}%. Green popust {green}%.",
    hu: "Az Ön RED kedvezménye {red}%. Green kedvezmény {green}%.",
    it: "Il tuo sconto RED è {red}%. Sconto Green {green}%.",
    lt: "Jūsų RED nuolaida yra {red}%. Green nuolaida {green}%.",
    nl: "Uw RED-korting is {red}%. Green-korting {green}%.",
    pl: "Twój rabat RED to {red}%. Rabat Green {green}%.",
    'pt-PT': "O seu desconto RED é {red}%. Desconto Green {green}%.",
    ro: "Reducerea RED este {red}%. Reducere Green {green}%.",
    sk: "Vaša veľkoobchodná zľava RED je {red}%. Zľava Green {green}%.",
    sl: "Vaš RED popust je {red}%. Green popust {green}%.",
    sv: "Din RED-rabatt är {red}%. Green-rabatt {green}%.",
  };
  var lang = (document.documentElement.lang || 'en').split('-')[0];
  // Special case for pt-PT
  if(document.documentElement.lang && document.documentElement.lang.toLowerCase().startsWith('pt-pt')) lang = 'pt-PT';
  
  // Get green discount from data attribute if available
  green = badge.getAttribute('data-green-discount') || '';
  
  var text = badgeTooltipTexts[lang] || badgeTooltipTexts['en'];
  text = text.replace('{red}', red).replace('{green}', green);
  tooltip.textContent = text;

  badge.addEventListener('mouseenter', function() {
    tooltip.style.display = 'block';
    tooltip.style.opacity = '1';
  });
  badge.addEventListener('mouseleave', function() {
    tooltip.style.display = 'none';
    tooltip.style.opacity = '0';
  });
  badge.addEventListener('focus', function() {
    tooltip.style.display = 'block';
    tooltip.style.opacity = '1';
  });
  badge.addEventListener('blur', function() {
    tooltip.style.display = 'none';
    tooltip.style.opacity = '0';
  });
});

// ==============================================
// Hero Account Menu Popover
// ==============================================
document.addEventListener('DOMContentLoaded', function() {
  const heroAccountMenuWrapper = document.querySelector('.hero-account-menu-wrapper');
  if (heroAccountMenuWrapper) {
    const trigger = heroAccountMenuWrapper.querySelector('.hero-account-menu-trigger');
    const popover = heroAccountMenuWrapper.querySelector('.hero-account-menu-popover');
    
    if (trigger && popover) {
      let isOpen = false;
      
      function openPopover() {
        isOpen = true;
        trigger.setAttribute('aria-expanded', 'true');
        popover.setAttribute('aria-hidden', 'false');
        // Add click outside listener
        setTimeout(() => {
          document.addEventListener('click', handleClickOutside);
        }, 10);
      }
      
      function closePopover() {
        isOpen = false;
        trigger.setAttribute('aria-expanded', 'false');
        popover.setAttribute('aria-hidden', 'true');
        document.removeEventListener('click', handleClickOutside);
      }
      
      function togglePopover() {
        if (isOpen) {
          closePopover();
        } else {
          openPopover();
        }
      }
      
      function handleClickOutside(event) {
        if (!heroAccountMenuWrapper.contains(event.target)) {
          closePopover();
        }
      }
      
      // Toggle on click
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        togglePopover();
      });
      
      // Close on escape key
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && isOpen) {
          closePopover();
          trigger.focus();
        }
      });
      
      // Handle keyboard navigation within popover
      popover.addEventListener('keydown', function(event) {
        const menuItems = popover.querySelectorAll('.hero-account-menu-item');
        const currentIndex = Array.from(menuItems).indexOf(document.activeElement);
        
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            const nextIndex = currentIndex < menuItems.length - 1 ? currentIndex + 1 : 0;
            menuItems[nextIndex].focus();
            break;
          case 'ArrowUp':
            event.preventDefault();
            const prevIndex = currentIndex > 0 ? currentIndex - 1 : menuItems.length - 1;
            menuItems[prevIndex].focus();
            break;
          case 'Tab':
            if (event.shiftKey && currentIndex === 0) {
              closePopover();
              trigger.focus();
            } else if (!event.shiftKey && currentIndex === menuItems.length - 1) {
              closePopover();
            }
            break;
        }
      });
    }
  }
});

// ==============================================
// Comparison Count Update
// ==============================================
document.addEventListener('DOMContentLoaded', function() {
  const comparisonCountBubble = document.querySelector('.header__icon--compare .comparison-count-bubble');
  const comparisonCountSpan = comparisonCountBubble ? comparisonCountBubble.querySelector('span') : null;

  function updateComparisonCount() {
    if (!comparisonCountBubble || !comparisonCountSpan) return;
    let count = 0;
    if (window.RdnlComparison && typeof window.RdnlComparison.getAll === 'function') {
      const items = window.RdnlComparison.getAll();
      count = items.length;
    } else {
      const storedItems = localStorage.getItem('rendl_compare');
      if (storedItems) {
        try {
          const parsedItems = JSON.parse(storedItems);
          if (Array.isArray(parsedItems)) {
            count = parsedItems.length;
          } else if (parsedItems && parsedItems.categories && Array.isArray(parsedItems.categories)) {
            count = parsedItems.categories.reduce((acc, category) => acc + (category.items ? category.items.length : 0), 0);
          }
        } catch (e) {
          console.error('Error parsing comparison from localStorage:', e);
        }
      }
    }
    comparisonCountSpan.textContent = count;
    if (count > 0) {
      comparisonCountBubble.style.display = 'flex';
    } else {
      comparisonCountBubble.style.display = 'none';
    }
  }
  updateComparisonCount();
  document.addEventListener('comparison:updated', updateComparisonCount);
  document.addEventListener('compare:updated', updateComparisonCount);
  // Retry after delays in case scripts are not immediately available
  if (!window.RdnlComparison) {
    setTimeout(updateComparisonCount, 500);
    setTimeout(updateComparisonCount, 1500);
  }
});

// ==============================================
// Show More Functionality (Event Delegation)
// ==============================================
document.addEventListener('click', function(e) {
  if (e.target.matches('.hero-mega-menu__show-more') || e.target.closest('.hero-mega-menu__show-more')) {
    const btn = e.target.matches('.hero-mega-menu__show-more') ? e.target : e.target.closest('.hero-mega-menu__show-more');
    e.preventDefault();
    e.stopPropagation();
    
    const column = btn.closest('.hero-mega-menu__column-content');
    if (!column) return;
    
    const hiddenItems = column.querySelector('.hero-mega-menu__hidden-items');
    if (!hiddenItems) return;
    
    if (hiddenItems.classList.contains('show')) {
      hiddenItems.classList.remove('show');
      const showText = btn.getAttribute('data-show-text');
      const arrowImg = btn.querySelector('img');
      if (arrowImg) {
        // Clone the arrow before clearing the button content
        const newArrow = arrowImg.cloneNode(true);
        newArrow.style.transform = 'rotate(0deg)';
        btn.innerHTML = showText + ' ';
        btn.appendChild(newArrow);
      } else {
        btn.innerHTML = showText;
      }
    } else {
      hiddenItems.classList.add('show');
      const hideText = btn.getAttribute('data-hide-text');
      const arrowImg = btn.querySelector('img');
      if (arrowImg) {
        // Clone the arrow before clearing the button content
        const newArrow = arrowImg.cloneNode(true);
        newArrow.style.transform = 'rotate(180deg)';
        btn.innerHTML = hideText + ' ';
        btn.appendChild(newArrow);
      } else {
        btn.innerHTML = hideText;
      }
    }
  }
});

// ==============================================
// Collection Image Tooltip Functionality
// ==============================================
document.addEventListener('DOMContentLoaded', function() {
  const tooltip = document.createElement('div');
  tooltip.className = 'hero-mega-menu__tooltip';
  tooltip.style.cssText = 'position: fixed; opacity: 0; visibility: hidden; z-index: 10000; pointer-events: none; transition: opacity 0.3s ease, visibility 0.3s ease; cursor: pointer;';
  document.body.appendChild(tooltip);

  const tooltipImg = document.createElement('img');
  tooltipImg.style.cssText = 'width: 170px; height: 170px; object-fit: cover; display: block; box-shadow: 0 4px 20px rgba(0,0,0,0.15);';
  tooltip.appendChild(tooltipImg);

  let hideTimeout = null;
  let currentLink = null;
  let currentCategoryButton = null;

  // Add click handler to tooltip for category buttons
  tooltip.addEventListener('click', function(e) {
    if (currentCategoryButton) {
      e.preventDefault();
      e.stopPropagation();
      // Hide tooltip immediately
      tooltip.style.opacity = '0';
      tooltip.style.visibility = 'hidden';
      tooltip.style.pointerEvents = 'none';
      // Trigger click on the category button to open menu
      currentCategoryButton.click();
      currentCategoryButton = null;
      currentLink = null;
    }
  });

  // Keep tooltip visible when hovering over it (for category tooltips)
  tooltip.addEventListener('mouseenter', function() {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }
  });

  tooltip.addEventListener('mouseleave', function() {
    hideTooltip();
  });

  function extractCollectionHandle(url) {
    if (!url || !url.includes('/collections/')) return null;
    const parts = url.split('/collections/')[1];
    if (!parts) return null;
    return parts.split('/')[0].split('?')[0].split('#')[0];
  }

  function showTooltip(link, handle) {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }

    if (typeof window.collectionImagesData === 'undefined') return;
    const collectionData = window.collectionImagesData[handle];
    if (!collectionData || !collectionData.image) return;

    currentLink = link;
    currentCategoryButton = null;
    tooltipImg.src = collectionData.image;
    updateTooltipPosition(link, 'left');
    
    // Disable pointer events for regular collection tooltips
    tooltip.style.pointerEvents = 'none';
    
    setTimeout(() => {
      tooltip.style.opacity = '1';
      tooltip.style.visibility = 'visible';
    }, 10);
  }

  function showCategoryTooltip(button, imageUrl) {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }

    currentLink = button;
    currentCategoryButton = button;
    tooltipImg.src = imageUrl;
    updateTooltipPosition(button, 'below');
    
    // Enable pointer events for category tooltips
    tooltip.style.pointerEvents = 'auto';
    
    // Trigger animation after position is set
    setTimeout(() => {
      tooltip.style.opacity = '1';
      tooltip.style.visibility = 'visible';
    }, 10);
  }

  function hideTooltip() {
    hideTimeout = setTimeout(() => {
      tooltip.style.opacity = '0';
      tooltip.style.visibility = 'hidden';
      tooltip.style.pointerEvents = 'none';
      currentLink = null;
      currentCategoryButton = null;
    }, 100);
  }

  function updateTooltipPosition(link, mode) {
    const rect = link.getBoundingClientRect();
    const tooltipWidth = 170;
    const tooltipHeight = 170;
    const offset = 12;

    let left, top;

    if (mode === 'below') {
      // First-level category buttons: show below, aligned to left of button
      left = rect.left;
      top = rect.bottom + offset;

      if (left + tooltipWidth > window.innerWidth - 10) {
        left = window.innerWidth - tooltipWidth - 10;
      }
      if (left < 10) left = 10;
      if (top + tooltipHeight > window.innerHeight - 10) {
        top = rect.top - tooltipHeight - offset;
      }
      if (top < 10) top = 10;
    } else {
      // Sub-items: show to the left, vertically centered
      left = rect.left - tooltipWidth - offset;
      const linkMid = rect.top + rect.height / 2;
      top = linkMid - tooltipHeight / 2;

      if (left < 10) {
        left = rect.right + offset;
      }
      if (left + tooltipWidth > window.innerWidth - 10) {
        left = window.innerWidth - tooltipWidth - 10;
      }
      if (top + tooltipHeight > window.innerHeight - 10) {
        top = window.innerHeight - tooltipHeight - 10;
      }
      if (top < 10) top = 10;
    }

    tooltip.style.left = left + 'px';
    tooltip.style.top = top + 'px';
  }

  // Add hover listeners to all collection links in mega menu
  const menuLinks = document.querySelectorAll('.hero-mega-menu__column li a, .hero-mega-menu__column h3 a');
  
  menuLinks.forEach(link => {
    const handle = extractCollectionHandle(link.getAttribute('href'));
    if (!handle) return;

    link.addEventListener('mouseenter', function() {
      showTooltip(this, handle);
    });

    link.addEventListener('mouseleave', function() {
      hideTooltip();
    });
  });

  // Add hover listeners to category buttons
  const categoryButtons = document.querySelectorAll('.hero-mega-menu__item > button[data-category-image]');
  
  categoryButtons.forEach(button => {
    const imageUrl = button.getAttribute('data-category-image');
    if (!imageUrl) return;

    button.addEventListener('mouseenter', function() {
      showCategoryTooltip(this, imageUrl);
    });

    button.addEventListener('mouseleave', function() {
      hideTooltip();
    });
  });

  // Update tooltip position on scroll
  window.addEventListener('scroll', function() {
    if (currentLink && tooltip.style.opacity === '1') {
      updateTooltipPosition(currentLink, currentCategoryButton ? 'below' : 'left');
    }
  }, { passive: true });
});

